module.exports = __webpack_public_path__ + "img/home-content-1.c99f379b.png";